import { select as $ } from './dom'
import Cleave from 'cleave.js';

export class ProfileDetailForm {
	constructor(el) {
		this.el = el
		this.contactPreference = $('[name="telemedicine_intakes_v2_on_demand_identities_profile_detail_form[contact_preference]"]', el)
		this.contactPreference.addEventListener('change', this.handleContactPreferenceChange.bind(this))
		this.work_phone = document.querySelector('#telemedicine_intakes_v2_on_demand_identities_profile_detail_form_work_phone');
		new Cleave(this.work_phone, {
			numericOnly: true,
			delimiter: '-',
			blocks: [3, 3, 4],
		});
		this.mobile_phone = document.querySelector('#telemedicine_intakes_v2_on_demand_identities_profile_detail_form_mobile_phone');
		new Cleave(this.mobile_phone, {
			numericOnly: true,
			delimiter: '-',
			blocks: [3, 3, 4],
    });
	}

	handleContactPreferenceChange(event) {
    $('#work-phone-label span').classList.add('hidden')
    $('#mobile-phone-label span').classList.add('hidden')
		$('#telemedicine_intakes_v2_on_demand_identities_profile_detail_form_mobile_phone').removeAttribute('required')
		$('#telemedicine_intakes_v2_on_demand_identities_profile_detail_form_work_phone').removeAttribute('required')
		this.showContactPreferenceFields(event.target.value)
	}

	showContactPreferenceFields(contactPreferenceValue) {
		switch (contactPreferenceValue) {
			case 'WORKPHONE':
				$('#work-phone-label span').classList.remove('hidden')
				$('#telemedicine_intakes_v2_on_demand_identities_profile_detail_form_work_phone').setAttribute('required', '')
				break
			case 'MOBILEPHONE':
				$('#mobile-phone-label span').classList.remove('hidden')
				$('#telemedicine_intakes_v2_on_demand_identities_profile_detail_form_mobile_phone').setAttribute('required', '')
				break
		}
  }
}
